/// ##### Animated icon

const iconsWrapper = document.querySelectorAll('.section-breadcrumbs-title__icon-wrapper');

if (iconsWrapper && iconsWrapper.length > 0) {
    window.addEventListener('scroll', () => {
        iconsWrapper.forEach((iconWrapper) => {
            const boundingRect = iconWrapper.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const percentage = Math.max(
                0,
                Math.min(
                    100,
                    ((viewportHeight - boundingRect.top) /
                        (viewportHeight + boundingRect.height)) *
                        100
                )
            );
            console.log(percentage);

            if (percentage >= 50 && percentage <= 75) {
                iconWrapper.classList.add('active-1');
            } else if (percentage > 75) {
                iconWrapper.classList.remove('active-1');
                iconWrapper.classList.add('active-2');
            } else if (percentage < 42) {
                iconWrapper.classList.remove('active-1');
                iconWrapper.classList.remove('active-2');
            }
        })
    })
}